import styled from "styled-components"; 

export const ContainerResumenLista = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-left: 20px;
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  margin-top: 14px;
  gap: 18px;
`;